import { useEffect, useState } from 'react';  
import { Container } from "react-bootstrap";
import IgvTrackViewer from "./track-viewer";
import { apiUrl } from "../config/default";
import { tissueTranslate, backboneTranslate } from './dictionaries';
import { format } from 'path';


export default function CoordinateViewer(props: any) {

    const {contentData} = props;
    const [additionalData, setAdditionalData] = useState<any>([]);
    const [dataLoading, setDataLoading] = useState(true);

    console.log(contentData)
    useEffect(() => {
        if(contentData !== null && contentData.assembly !== null) {
            let assembly = "hg38";
            let coord = contentData.coordinate_hg38;
            let filter = "coordinate_hg38";
            if (contentData.assembly === "mm10") {
                assembly = "mm10";
                filter = "coordinate_mm10";
                coord = contentData.coordinate_mm10;
            }
            let splitted = coord.split(":");
            let chr = splitted[0];
            let url = apiUrl + "/catalogs/externalBrowse?"+filter+"="+chr+":1-999999999999&assembly="+assembly;
            fetch(url).then(
                res => res.json()
            ).then(
                (result) => {
                    let additional = [];
                    let ref = contentData.vista_id + "." + contentData.allele_id + "_" + contentData.stage + "_" + contentData.backbone;
                    for(let i = 0; i < result.data.length; i+=1) {
                                        let line = result.data[i];
                                        let test = line.vista_id + "." + line.allele_id + "_" + line.stage + "_" + line.backbone
                                        if(test !== ref) {
                                            additional.push(line)
                                        }
                    }
                    setAdditionalData(additional);
                    setDataLoading(false);
                }
            );
        }
        
    }, []);




    const randomColorGenerator = () => {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
      };


      const colorByStatus = (status:string) => {
        let color = "blue";
        if(status === "negative")
            color = "grey";
        if(status === "manually curated" || status === null || status === "allelic")
            color = "orange";
        return color
      };



    const formatTissuesForFeature = (contentObj: any) => {
        let f_tissue = contentObj["tissue"];
                if(contentObj["curation_status"] !== "positive") {
                    f_tissue = "none";
                    
                }
                else {
                    let tissues = f_tissue.split(";");
                    let tissues_hr = [];
                    for(var t=0; t < tissues.length; t+=1) {
                        tissues_hr.push(tissueTranslate(tissues[t], 'label'));
                    }
                    f_tissue = tissues_hr.join(", ");
                }
        return f_tissue;
    }


    const createViewerWindow = () => {
        if(!contentData|| !contentData.assembly)
            return null;

        var assembly = 'hg38';
        var coord = contentData.coordinate_hg38;
        var header = contentData.vista_id+'.'+contentData.allele_id+" - "+contentData.backbone+" - "+contentData.stage;
        if(contentData.assembly === 'mm10'){
            assembly = 'mm10';
            coord = contentData.coordinate_mm10;
        }
        if(coord === null) {
            return null;
        }


        var splitted = coord.split(":");
        var chr = splitted[0];
        var coords = splitted[1].split("-");
        var reference_track = [
            {
              "name": "Current Experiment",
              "type": "annotation",
              "color": "",
              "format": "bed",
              "searchable": true,
              "height": "",
              "features": [
                {
                    "chr": chr,
                    "start": Number(coords[0]),
                    "end": Number(coords[1]),
                    "name": header,
                    "curation status": contentData.curation_status,
                    "promoter": backboneTranslate(contentData.backbone, "promoter"),
                    "transgenesis": backboneTranslate(contentData.backbone, "transgenesisType"),
                    "tissues": formatTissuesForFeature(contentData)
                }
            ]
            }
          ];


        var features: any[] = [];
        if(additionalData !== null) {
            
            for(var i = 0; i < additionalData.length; i+=1) {
                let f_header = additionalData[i].vista_id+'.'+additionalData[i].allele_id+" - "+additionalData[i].backbone+" - "+additionalData[i].stage;
                let splitted = additionalData[i].coordinate_hg38.split(":")
                if (additionalData[i].assembly === "mm10") {
                    splitted = additionalData[i].coordinate_mm10.split(":")
                }
                let f_chr = splitted[0];
                let f_coords = splitted[1].split("-");
                let f_start = Number(f_coords[0]);
                let f_end = Number(f_coords[1]);
                let f_tissue = formatTissuesForFeature(additionalData[i]);
                
                let f_status = additionalData[i].curation_status;
                if(f_status === null) {
                    f_status = "manually curated"
                }
                //"features": [{"chr": chr, "start": Number(coords[0]), "end": Number(coords[1]), "name": this.header}]
                features.push(
                    {
                        "chr": f_chr,
                        "start": f_start,
                        "end": f_end,
                        "name": f_header,
                        "color": colorByStatus(f_status),
                        "curation status": f_status,
                        "promoter": backboneTranslate(additionalData[i].backbone, "promoter"),
                        "transgenesis": backboneTranslate(additionalData[i].backbone, "transgenesisType"),
                        "tissues": f_tissue,
                    }
                )
            }
        }
        var additional_tracks: any[]|null;
        if(features.length > 0) {
            additional_tracks = [
                {
                    "name": "Other Experiments",
          "type": "annotation",
          "color": "",
          "format": "bed",
          "searchable": true,
          "height": "800",
          "features": features
                }]
            
        }
        else {
            additional_tracks = null;
        }
        return(
            
            <IgvTrackViewer assembly={assembly} header={header} coordinates={coord} reference_track={reference_track} additional_track={additional_tracks} curation_page={false} vcf={null}></IgvTrackViewer>
        )
    };

    if(dataLoading) {
        return null;
    }
    else {
        return(
            <Container>{createViewerWindow()}</Container>
        )
    }
}